import { CareerRecommendInfo, TrnCareerRecommendUpdateForm } from '@/types';

const mapperToTrnCareerRecommendUpdateForm = (params: CareerRecommendInfo): TrnCareerRecommendUpdateForm =>
{
  let i = 0;
  const dataForm : TrnCareerRecommendUpdateForm = {};

  if (params.wishWkAreaAllFlg != null)
  {
    if (params.wishWkAreaAllFlg) {
        dataForm.wishWkAreaAllFlg = 1;
      } else {
        dataForm.wishWkAreaAllFlg = 0;
      }
  }

  if(params.wishWkAreaIds && params.wishWkAreaIds.length > 0 && params.wishWkAreaIds.length <= 3)
  {
    for(i = 0; i < params.wishWkAreaIds.length; i++)
    {
      if (params.wishWkAreaIds[i]) {
        (dataForm as any)[`wishWkArea${i + 1}Id`] = params.wishWkAreaIds[i];
      }
    }
  }
  if (params.wishWkAreaIds != null && params.wishWkAreaIds.length > 0)
    dataForm.wishWkAreaIds = params.wishWkAreaIds;
  
  if(params.changeAddrFlg != null)
      dataForm.changeAddrFlg = params.changeAddrFlg;
  if(params.wishIndsCtgIds && params.wishIndsCtgIds.length > 0 && params.wishIndsCtgIds.length <= 6)
  {
    for(i = 0; i < params.wishIndsCtgIds.length; i++)
    {   
        if ( params.wishIndsCtgIds[i])
          (dataForm as any)[`wishIndsCtg${i + 1}Id`] = params.wishIndsCtgIds[i];
    }
  }

  if(params.wishOcupCtgIds && params.wishOcupCtgIds.length > 0 && params.wishOcupCtgIds.length <= 6)
  {
    for(i = 0; i < params.wishOcupCtgIds.length; i++)
    {
        if(params.wishOcupCtgIds[i])
        {
          (dataForm as any)[`wishOcupCtg${i + 1}Id`] = params.wishOcupCtgIds[i];
        }
    }
  }
  if (params.wishEmployeeId != null)
    dataForm.wishEmployeeId = params.wishEmployeeId;

  if(params.wishSalaryNotParticularFlg != null)
  {
    if(params.wishSalaryNotParticularFlg)
      dataForm.wishSalaryNotParticularFlg = 1;
    else
      dataForm.wishSalaryNotParticularFlg = 0;
  }

   if(params.wishIndsCtgNotParticularFlg != null)
   {
      if(params.wishIndsCtgNotParticularFlg)
      {
        dataForm.wishIndsCtgNotParticularFlg = 1;
      }
      else
      {
        dataForm.wishIndsCtgNotParticularFlg = 0;
      }
   }

   if(params.wishOcupCtgNotParticalarFlg != null)
   {
    if(params.wishOcupCtgNotParticalarFlg)
      dataForm.wishOcupCtgNotParticalarFlg = 1;
    else
      dataForm.wishOcupCtgNotParticalarFlg = 0;
   }

  if(params.wishAnnualIncomeNum != null)
    dataForm.wishAnnualIncomeNum = params.wishAnnualIncomeNum;

  if(params.minWishAnnualIncomeNum != null)
    dataForm.minWishAnnualIncomeNum = params.minWishAnnualIncomeNum;

  if(params.jobChangeFlg != null)
    dataForm.jobChangeFlg = params.jobChangeFlg;

  if(params.changeJobReason != null)
    dataForm.changeJobReason = params.changeJobReason;

  if(params.changeJobPriority != null)
    dataForm.changeJobPriority = params.changeJobPriority;

  if(params.careerChangeAgentFlg != null)
  {
    dataForm.careerChangeAgentFlg = params.careerChangeAgentFlg;
    dataForm.careerChangeAgentMemo = params.careerChangeAgentMemo;
  }

  if (params.jobChangeSiteFlg != null) {
    dataForm.jobChangeSiteFlg = params.jobChangeSiteFlg;
    dataForm.jobChangeSiteMemo = params.jobChangeSiteMemo;
  }


if (params.helloWorkFlg != null)
  dataForm.helloWorkFlg = params.helloWorkFlg;

if (params.clientNameRemindOtherFlg != null)
{
  if(params.clientNameRemindOtherFlg)
    dataForm.clientNameRemindOtherFlg = 1;
  else    
    dataForm.clientNameRemindOtherFlg = 0;
}

if (params.clientNameRemindOther != null)
  dataForm.clientNameRemindOther = params.clientNameRemindOther;


  if(params.purposeAgentIds)
  {
    dataForm.purposeAgentIds = params.purposeAgentIds;
  }

if (params.purposeAgentMemo != null)
  dataForm.purposeAgentMemo = params.purposeAgentMemo;

  if(params.lsTrnJobChangeStatus)
  {
    dataForm.lsTrnJobChangeStatusUpdate = [];
    if (params.lsTrnJobChangeStatus) {
      params.lsTrnJobChangeStatus.forEach(job => {
        const normalizedJob = {
          ...job,
          clientNameRemind: job.clientNameRemind?.trim() === '' ? '' : job.clientNameRemind,
        };
        if (normalizedJob.aspirationId || normalizedJob.clientNameRemind || normalizedJob.courseId || normalizedJob.selectionPhaseId) {
          dataForm.lsTrnJobChangeStatusUpdate?.push(normalizedJob);
        }
      });
    }
  }
  return dataForm;
};

export const recommendFormUtils = {
  mapperToTrnCareerRecommendUpdateForm,
};